import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Drawer from "../Drawer";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import _ from "lodash";
import { getImageUrl } from "Common/utils/ImageDomain";
import ImageView from "../ImageView/ImageView";
import { showNotification } from "Common/utils/Notification";
import contentType from "../../../constants/contentType.json";
import ReactSelect from "../ReactSelect/ReactSelect2";
import LoaderComponent from "../Loader/Loader";
import ImageData from "../customImage/ImageSegment";
import Button from "../ButtonComponent/Button";
import TwoColumnScrollSegmentCard from "./TwoColumnScrollSegmentCard";
import CustomInput from "../InputFields/CustomInput";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";

/* 
{
  "header_text": "",
  "subheader_text": "",
  "view_url": "",
  "segments": [{ icon: "", description: "" }]
}
*/

const TwoColumnScroll = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  segmentType,
  toggleVisiblity,
  versionData,
  segmentId,
}) => {
  const [segments, setSegments] = useState<any>([]);
  const [headerText, setHeaderText] = useState(
    data?.header_text ? data?.header_text : ""
  );
  const [isLoading, setIsLoading] = useState<any>(false);
  const [onecolumnContent, setOneColumnContent] = useState<any>([]);
  const [twocolumnContent, setTwoColumnContent] = useState<any>([]);
  const [imageUrl, setImageUrl] = useState<any>();
  const [backgroundImage, setBackgroundImage] = useState<any>(
    data?.background_image
  );
  const [backgroundImageId, setBackgroundImageId] = useState<any>("");
  const [mobileBackground, setMobileBackground] = useState<any>(
    data?.mobile_background_image
  );
  const [mobileBackgroundId, setMobileBackgroundId] = useState<any>("");
  const [subHeaderText, setSubHeaderText] = useState(data?.style);
  const [eventData, setEventData] = useState<any>();
  const [showVideo, setShowVideo] = useState(false);
  const [index, setIndex] = useState(undefined);
  const [indexBack, setIndexBack] = useState(undefined);
  const [errors, setErrors] = useState<any>({
    segments: segments?.map(() => ({
      header_text: "",
      column_one_content_type: "",

      column_two_content_type: "",
    })),
  });
  useEffect(() => {
    if (data?.list?.[0]?.header_text) {
      setSegments(data.list);

      const newOneColumnContent = [];
      const newTwoColumnContent = [];

      data.list.forEach((item) => {
        // Update column one content
        if (item?.column_one_content_type === contentType[1].value) {
          newOneColumnContent.push(contentType[1]);
        } else if (item?.column_one_content_type === contentType[2].value) {
          newOneColumnContent.push(contentType[2]);
        }

        // Update column two content
        if (item?.column_two_content_type === contentType[1].value) {
          newTwoColumnContent.push(contentType[1]);
        } else if (item?.column_two_content_type === contentType[2].value) {
          newTwoColumnContent.push(contentType[2]);
        }
      });

      setOneColumnContent(newOneColumnContent);
      setTwoColumnContent(newTwoColumnContent);
    }
  }, [data]);
  const toggle = () => setShowVideo(!showVideo);
  useEffect(() => {
    //setImageUrl(eventData?.media_url);

    if (eventData && eventData?.media_url) {
      if (eventData?.media_type === "image") {
        if (indexBack === undefined) {
          if (imageUrl === "column_two_image_url") {
            handleSegmentInputChange(
              index,
              "column_two_image_url",
              eventData.media_url
            );
            handleSegmentInputChange(
              index,
              "column_two_image_id",
              eventData._id
            );
          } else {
            handleSegmentInputChange(
              index,
              "column_one_image_url",
              eventData.media_url
            );
            handleSegmentInputChange(
              index,
              "column_one_image_id",
              eventData._id
            );
          }
        } else if (indexBack === "background") {
          setBackgroundImage(eventData?.media_url);
          setBackgroundImageId(eventData?._id);
        } else if (indexBack === "mobile") {
          setMobileBackground(eventData.media_url);
          setMobileBackgroundId(eventData._id);
          setErrors((prev) => ({ ...prev, ["mobile_background_image"]: "" }));
        }
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [eventData, index, indexBack, imageUrl]);

  const addSegment = () => {
    setSegments([
      ...segments,
      {
        header_text: "",
        column_one_content_type: "",
        column_one_text: "",
        column_one_image_url: "",
        column_two_content_type: "",
        column_two_image_url: "",
        column_two_text: "",
        // column_two_image_id: "",
      },
    ]);
    setOneColumnContent([...onecolumnContent, { label: "", value: "" }]);
    setTwoColumnContent([...twocolumnContent, { label: "", value: "" }]);
    setErrors({
      ...errors,
      segments: [
        ...errors.segments,
        {
          header_text: "",
          column_one_content_type: "",

          column_two_content_type: "",
        },
      ],
    });
  };

  const removeSegment = (index) => {
    const updatedSegments = segments.filter((_, i) => i !== index);
    setSegments(updatedSegments);
    const updateColOne = onecolumnContent.filter((_, i) => i !== index);
    setOneColumnContent(updateColOne);
    const updateColTwo = twocolumnContent.filter((_, i) => i !== index);
    setTwoColumnContent(updateColTwo);
    const updatedErrors = { ...errors };
    updatedErrors.segments.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleSegmentInputChange = (index, field, value) => {
    const updateColOne = onecolumnContent.map((item, i) => {
      if (i === index) {
        if (field === "column_one_content_type") {
          if (value.value === "text") {
            item.label = value.label;
            item.value = value.value;
          } else if (value.value === "image") {
            item.label = value.label;
            item.value = value.value;
          }
        }
      }
      return item;
    });
    setOneColumnContent(updateColOne);
    const updateColtwo = twocolumnContent.map((item, i) => {
      if (i === index) {
        if (field === "column_two_content_type") {
          if (value.value === "text") {
            item.label = value.label;
            item.value = value.value;
          } else if (value.value === "image") {
            item.label = value.label;
            item.value = value.value;
          }
        }
      }
      return item;
    });
    setTwoColumnContent(updateColtwo);
    const updatedSegments = segments.map((button, i) => {
      if (i === index) {
        if (field === "column_one_content_type") {
          if (value.value === "Select...") {
            button[field] = "";
          } else {
            if (value.value === "text") {
              button["column_one_image_url"] = "";
              button["column_one_image_id"] = "";
              button[field] = value.value;
            } else {
              button["column_one_text"] = "";
              button[field] = value.value;
            }
          }
        } else if (field === "column_two_content_type") {
          if (value.value === "Select...") {
            button[field] = "";
          } else {
            if (value.value === "text") {
              button["column_two_image_url"] = "";
              button["column_two_image_id"] = "";
              button[field] = value.value;
            } else {
              button["column_two_text"] = "";
              button[field] = value.value;
            }
          }
        } else {
          button[field] = value;
        }
      }
      return button;
    });
    setSegments(updatedSegments);

    const updatedErrors = { ...errors };
    if (updatedErrors.segments[index]) {
      updatedErrors.segments[index][field] = "";
    }
    setErrors(updatedErrors);
  };
  const handleRemoveOneColumnImage = (index) => {
    setSegments((prevSegments) =>
      prevSegments.map((segment, i) =>
        i === index ? { ...segment, column_one_image_url: "" } : segment
      )
    );
  };
  const handleRemoveTwoColumnImage = (index) => {
    setSegments((prevSegments) =>
      prevSegments.map((segment, i) =>
        i === index ? { ...segment, column_two_image_url: "" } : segment
      )
    );
  };
  const handleSave = async (pageId, id) => {
    const newErrors = {
      segments: segments?.map(() => ({
        header_text: "",
        column_one_content_type: "",

        column_two_content_type: "",
      })),
    };

    segments?.forEach((award, index) => {
      if (!award.column_one_content_type?.trim()) {
        newErrors.segments[index].column_one_content_type =
          "Column one content type is required.";
      }
      if (!award.header_text?.trim()) {
        newErrors.segments[index].header_text = "Header text is required.";
      }

      if (!award.column_two_content_type?.trim()) {
        newErrors.segments[index].column_two_content_type =
          "Column two content type is required.";
      }
    });

    setErrors(newErrors);

    if (
      newErrors?.segments?.every(
        (error) =>
          !error.column_two_content_type &&
          !error.header_text &&
          !error.column_one_content_type
      )
    ) {
      const payload = {
        segment_type: "twocolumnscroll_segments",
        header_text: headerText,
        style: subHeaderText,
        list: segments,
        

        background_image: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImage,
        background_image_id: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImageId,
        mobile_background_image_id: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackgroundId,
        mobile_background_image: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackground
      };

      try {
        setIsLoading(true);
        const response = await callApi(
          `v1/page/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification(
            "Two Column Scroll Segment saved successfully!",
            "success"
          );
        }
      } catch (e) {
        showNotification("An error occurred. Please try again.", "error");
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        {/* Header Text */}
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        <div>
          <div className="flex my-4">
            {backgroundImage ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={backgroundImage}
                  setImageData={setEventData}
                  setImageLink={setBackgroundImage}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggle();
                      setIndexBack("background");
                      setEventData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggle();
                  setIndexBack("background");
                  setEventData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add BackgroundImage
              </button>
            )}
          </div>
          {/* {errors.image_url && (
            <p className="text-sm text-red-500">{errors.image_url}</p>
          )} */}
        </div>
        <div>
          <div className="flex my-4">
            {mobileBackground ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={mobileBackground}
                  setImageData={setEventData}
                  setImageLink={setMobileBackground}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggle();
                      setIndexBack("mobile");
                      setEventData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggle();
                  setIndexBack("mobile");
                  setEventData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add MobileBackground
              </button>
            )}
          </div>
        </div>
        <div className="xl:col-span-12">
          <CustomInput
            label="Header Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Header Text"
            value={headerText}
            onChange={(e) => setHeaderText(e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.header_text}
            error={errors?.header_text}
          />
        </div>
        <div className="my-4 xl:col-span-12">
          <CustomInput
            label="Style"
            name="imageAlt"
            type="text"
            placeholder="Enter  style"
            value={subHeaderText}
            onChange={(e) => setSubHeaderText(e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.style}
            error={errors?.style}
          />
        </div>
        <div className="flex justify-end my-4">
          <button
            onClick={addSegment}
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Add two column scroll
          </button>
        </div>
        {versionData?.list?.length > 0 ? (
          <div className="grid grid-cols-1 gap-4 mb-2 xl:grid-cols-12">
            Old Data
          </div>
        ) : null}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {/* Render Segments */}
          {versionData?.list?.map((item, index) => (
            <div key={index} className="py-4 xl:col-span-4">
              <TwoColumnScrollSegmentCard
                index={index}
                singleColumnData={item}
                onecolumnContent={onecolumnContent}
                twocolumnContent={twocolumnContent}
                removeSegment={removeSegment}
                handleRemoveOneColumnImage={handleRemoveOneColumnImage}
                handleRemoveTwoColumnImage={handleRemoveTwoColumnImage}
                setImageUrl={setImageUrl}
                setIndex={setIndex}
                setIndexBack={setIndexBack}
                contentType={contentType}
                handleSegmentInputChange={handleSegmentInputChange}
                errors={errors}
                toggle={toggle}
                setEventData={setEventData}
                isEditable={false}
              />
            </div>
          ))}
        </div>
        {versionData?.list?.length > 0 ? (
          <div className="grid grid-cols-1 gap-4 mb-2 xl:grid-cols-12">
            New Data
          </div>
        ) : null}

        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {/* Render Segments */}
          {segments?.map((item, index) => (
            <div key={index} className="py-4 xl:col-span-4">
              <TwoColumnScrollSegmentCard
                index={index}
                singleColumnData={item}
                onecolumnContent={onecolumnContent[index]}
                twocolumnContent={twocolumnContent[index]}
                removeSegment={removeSegment}
                handleRemoveOneColumnImage={handleRemoveOneColumnImage}
                handleRemoveTwoColumnImage={handleRemoveTwoColumnImage}
                setImageUrl={setImageUrl}
                setIndex={setIndex}
                setIndexBack={setIndexBack}
                contentType={contentType}
                handleSegmentInputChange={handleSegmentInputChange}
                errors={errors}
                toggle={toggle}
                setEventData={setEventData}
                isEditable={isEditable}
              />
            </div>
          ))}
        </div>
        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />
          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showVideo}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showVideo}
            setEventData={setEventData}
            togleImage={toggle}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default TwoColumnScroll;
